import { createFileRoute, redirect, Outlet } from '@tanstack/react-router'
import { SidebarProvider, SidebarInset } from '@/components/ui/sidebar'
import { DashboardSidebar } from '@/components/dashboard/dashboard-sidebar'
import { adminSessionUtils } from '@/lib/auth-client'
import { AdminRoleProvider, useAdminAuth } from '@/components/auth/admin-auth-guard'

export const Route = createFileRoute('/dashboard')({
  beforeLoad: async () => {
    const isAdmin = await adminSessionUtils.isAuthenticated()
    if (!isAdmin) {
      throw redirect({ to: '/login', search: { error: 'admin_required', clearSession: 'true' } })
    }
  },
  component: DashboardLayout,
})

function DashboardLayout() {
  const defaultOpen = localStorage.getItem('sidebar_state') === 'true'
  const { canWrite, isLoading } = useAdminAuth()

  if (isLoading) return null

  return (
    <AdminRoleProvider canWrite={canWrite} role={canWrite ? 'admin' : 'viewer'}>
      <SidebarProvider defaultOpen={defaultOpen}>
        <DashboardSidebar />
        <SidebarInset>
          <Outlet />
        </SidebarInset>
      </SidebarProvider>
    </AdminRoleProvider>
  )
}
